<template>
  <div>
    <div class="pt-3 pb-16 Kanit mx-auto" style="max-width: 500px">
      <v-btn color="primary" @click="$emit('close')" text class="pl-0">
        <v-icon class="mr-2">mdi-chevron-left</v-icon>BACK
      </v-btn>
      <div class="pa-5">
        <div style="font-size: 19px; font-weight: 600">
          สมัครงาน {{ data.Position }}
        </div>
        <div style="font-size: 13px; color: grey">{{ data.Name }}</div>
      </div>
      <div class="px-2">
        <v-card outlined class="px-2 py-5" style="font-weight: 300">
          <ValidationObserver ref="observer">
            <ValidationProvider
              rules="required"
              name="ชื่อจริง"
              v-slot="{ errors }"
            >
              <v-text-field
                label="ชื่อจริง"
                outlined
                dense
                :error-messages="errors"
                v-model="input.first_name"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
              :rules="{
                required: true,
              }"
              name="นามสกุล"
              v-slot="{ errors }"
            >
              <v-text-field
                outlined
                dense
                class="pt-0"
                label="นามสกุล"
                :error-messages="errors"
                v-model="input.last_name"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
              :rules="{
                required: true,
              }"
              name="เพศ"
              v-slot="{ errors }"
            >
              <v-radio-group
                class="mt-0"
                dense
                label="เพศ"
                v-model="input.gender"
                :error-messages="errors"
              >
                <v-radio value="Male" label="ชาย"></v-radio>
                <v-radio value="Female" label="หญิง"></v-radio>
              </v-radio-group>
            </ValidationProvider>
            <ValidationProvider
              :rules="{
                required: true,
              }"
              name="วันเดือนปีเกิด"
              v-slot="{ errors }"
            >
              <BirthdayPicker v-model="input.dob">
                <v-text-field
                  class="pt-0"
                  outlined
                  readonly
                  dense
                  label="วันเดือนปีเกิด"
                  :error-messages="errors"
                  :value="dobformat"
                ></v-text-field>
              </BirthdayPicker>
            </ValidationProvider>
            <ValidationProvider
              :rules="{
                required: true,
                regex: /^[0-9]{13}|(?!^0+$)[a-zA-Z0-9]{3,20}$/,
                idcard: true,
              }"
              name="เลขประจำตัวประชาชน"
              v-slot="{ errors }"
            >
              <v-text-field
                class="pt-0"
                outlined
                dense
                maxlength="13"
                @keypress="onlyNumber"
                @paste="onlyNumber"
                label="เลขประจำตัวประชาชน"
                :error-messages="errors"
                v-model="input.id_card"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
              :rules="{
                required: true,
              }"
              name="สัญชาติ"
              v-slot="{ errors }"
            >
              <v-text-field
                outlined
                dense
                class="pt-0"
                label="สัญชาติ"
                :error-messages="errors"
                v-model="input.race"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
              :rules="{
                required: true,
              }"
              name="เชื้อชาติ"
              v-slot="{ errors }"
            >
              <v-text-field
                outlined
                dense
                class="pt-0"
                label="เชื้อชาติ"
                :error-messages="errors"
                v-model="input.nationality"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
              :rules="{
                required: true,
              }"
              name="ศาสนา"
              v-slot="{ errors }"
            >
              <v-text-field
                outlined
                dense
                class="pt-0"
                label="ศาสนา"
                :error-messages="errors"
                v-model="input.religion"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
              :rules="{
                required: true,
              }"
              name="ที่อยู่ปัจจุบัน"
              v-slot="{ errors }"
            >
              <v-text-field
                outlined
                dense
                class="pt-0"
                label="ที่อยู่ปัจจุบัน"
                :error-messages="errors"
                v-model="input.address"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
              :rules="{
                required: true,
                regex: /^[0][3-9][0-9]{4}[0-9]{4}$/,
              }"
              name="เบอร์โทรศัพท์"
              v-slot="{ errors }"
            >
              <v-text-field
                class="pt-0"
                outlined
                dense
                @keypress="onlyNumber"
                @paste="onlyNumber"
                label="เบอร์โทรศัพท์"
                :error-messages="errors"
                v-model="input.phone_number"
              ></v-text-field>
            </ValidationProvider>
            <ValidationProvider
              :rules="{
                required: true,
                email: true,
              }"
              name="เบอร์โทร"
              v-slot="{ errors }"
            >
              <v-text-field
                class="pt-0"
                outlined
                dense
                label="อีเมล"
                :error-messages="errors"
                v-model="input.email"
              ></v-text-field>
            </ValidationProvider>

            <div style="font-weight: 600; font-size: 18px" class="mb-2">
              ประวัติการทำงาน
            </div>
            <div v-if="input.work_experience && input.work_experience.length">
              <v-card
                color="#f3f3f3"
                :key="k"
                class="pa-2 mb-2"
                v-for="(item, k) in input.work_experience"
                style="position: relative"
              >
                <div class="text-center py-5 pb-0" style="color: darkgrey">
                  <div class="pt-2">
                    <div style="position: absolute; right: 0px; top: 0px">
                      <v-btn @click="deleteWork(item, k)" icon>
                        <v-icon>close</v-icon></v-btn
                      >
                    </div>
                    <ValidationProvider
                      :rules="{
                        required: true,
                      }"
                      name="ชื่อสถานที่ทำงาน"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        background-color="white"
                        class="pt-0"
                        outlined
                        dense
                        label="ชื่อสถานที่ทำงาน"
                        :error-messages="errors"
                        v-model="input.work_experience[k].work_name"
                      ></v-text-field>
                    </ValidationProvider>
                    <ValidationProvider
                      :rules="{
                        required: true,
                      }"
                      name="ตำแหน่งงาน"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        class="pt-0"
                        outlined
                        background-color="white"
                        dense
                        label="ตำแหน่งงาน"
                        :error-messages="errors"
                        v-model="input.work_experience[k].position"
                      ></v-text-field>
                    </ValidationProvider>
                    <ValidationProvider
                      :rules="{
                        required: true,
                      }"
                      name="อายุงาน"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        class="pt-0"
                        outlined
                        background-color="white"
                        dense
                        label="อายุงาน"
                        :error-messages="errors"
                        v-model="input.work_experience[k].years_experience"
                      ></v-text-field>
                    </ValidationProvider>
                    <ValidationProvider
                      :rules="{
                        required: true,
                      }"
                      name="ลักษณะงาน"
                      v-slot="{ errors }"
                    >
                      <v-textarea
                        rows="2"
                        class="pt-0"
                        background-color="white"
                        outlined
                        dense
                        textarea
                        label="ลักษณะงาน"
                        :error-messages="errors"
                        v-model="input.work_experience[k].detail"
                      ></v-textarea>
                    </ValidationProvider>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="text-center">
              <div class="pb-4">
                <v-btn @click="addworkexp" class="mt-2">
                  <v-icon>mdi-plus</v-icon>เพิ่มประวัติการทำงาน</v-btn
                >
              </div>
            </div>

            <div style="font-weight: 600; font-size: 18px" class="mb-2">
              ประวัติการศึกษา
            </div>
            <div v-if="input.edu_experience && input.edu_experience.length">
              <v-card
                color="#f3f3f3"
                :key="k"
                class="pa-2 mb-2"
                v-for="(item, k) in input.edu_experience"
                style="position: relative"
              >
                <div class="text-center py-5 pb-0" style="color: darkgrey">
                  <div class="pt-2">
                    <div style="position: absolute; right: 0px; top: 0px">
                      <v-btn @click="deleteEdu(item, k)" icon>
                        <v-icon>close</v-icon></v-btn
                      >
                    </div>
                    <ValidationProvider
                      :rules="{
                        required: true,
                      }"
                      name="ชื่อสถานศึกษา"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        background-color="white"
                        class="pt-0"
                        outlined
                        dense
                        label="ชื่อสถานศึกษา"
                        :error-messages="errors"
                        v-model="input.edu_experience[k].institute"
                      ></v-text-field>
                    </ValidationProvider>
                    <ValidationProvider
                      :rules="{
                        required: true,
                      }"
                      name="สาขาที่เรียน"
                      v-slot="{ errors }"
                    >
                      <v-text-field
                        class="pt-0"
                        outlined
                        background-color="white"
                        dense
                        label="สาขาที่เรียน"
                        :error-messages="errors"
                        v-model="input.edu_experience[k].faculty"
                      ></v-text-field>
                    </ValidationProvider>
                    <ValidationProvider
                      :rules="{
                        required: true,
                      }"
                      name="คุณวุฒิ"
                      v-slot="{ errors }"
                    >
                      <v-select
                        class="pt-0 Kanit"
                        outlined
                        :items="degreesOptions"
                        background-color="white"
                        dense
                        label="คุณวุฒิ"
                        :error-messages="errors"
                        v-model="input.edu_experience[k].degree"
                      ></v-select>
                    </ValidationProvider>
                    <ValidationProvider
                      :rules="{
                        required: true,
                      }"
                      name="เกรดเฉลี่ย"
                      v-slot="{ errors }"
                    >
                      <v-textarea
                        rows="2"
                        class="pt-0"
                        background-color="white"
                        outlined
                        dense
                        textarea
                        label="เกรดเฉลี่ย"
                        :error-messages="errors"
                        v-model="input.edu_experience[k].grade"
                      ></v-textarea>
                    </ValidationProvider>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="text-center">
              <div class="pb-4">
                <v-btn @click="addeduexp" class="mt-2">
                  <v-icon>mdi-plus</v-icon>เพิ่มประวัติการศึกษา</v-btn
                >
              </div>
            </div>
            <v-divider class="my-3"></v-divider>
            <ValidationProvider
              :rules="{
                required: false,
              }"
              name="แนบไฟล์"
              v-slot="{ errors }"
            >
              <UploadDocument :errors="errors" v-model="input.file_url">
              </UploadDocument>
            </ValidationProvider>
            <ValidationProvider
              :rules="{
                required: false,
              }"
              name="หมายเหตุ"
              v-slot="{ errors }"
            >
              <v-textarea
                rows="2"
                class="pt-0"
                background-color="white"
                outlined
                dense
                textarea
                label="หมายเหตุ"
                :error-messages="errors"
                v-model="input.note"
              ></v-textarea>
            </ValidationProvider>
          </ValidationObserver>
        </v-card>
      </div>
      <div class="text-center mt-6 px-3">
        <v-btn :loading="saveloading" large color="primary">สมัครงาน</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import BirthdayPicker from "@/components/BirthdayPicker.vue";
import UploadDocument from "@/components/UploadDocument.vue";
import moment from "moment";
export default {
  props: ["data"],
  components: {
    BirthdayPicker,
    UploadDocument,
  },
  data() {
    return {
      saveloading: false,
      degreesOptions: [
        "มัธยมศึกษาตอนปลาย",
        "ประกาศนียบัตรวิชาชีพ (ปวช.)",
        "ประกาศนียบัตรวิชาชีพชั้นสูง (ปวส.)",
        "ปริญญาตรี",
        "ปริญญาโท",
        "ปริญญาเอก",
        "อื่นๆ",
      ],
      input: {
        first_name: "",
        last_name: "",
        gender: "",
        dob: "",
        id_card: "",
        nationality: "",
        race: "",
        religion: "",
        address: "",
        phone_number: "",
        email: "",
        edu_experience: [],
        work_experience: [],
        file_url: "",
        note: "",
      },
    };
  },
  mounted() {
    var profile = this.$store.state.profiledata;
    var name = "";
    if (profile.name) {
      name = profile.name;
    } else if (profile.coordinator_name) {
      name = profile.coordinator_name;
    }
    if (name) {
      this.input.first_name = name.split(" ")[0];
      this.input.last_name = name.split(" ")[1];
    }
    if (profile.id_card) {
      this.input.id_card = profile.id_card;
    }
    if (profile.email) {
      this.input.email = profile.email;
    }
    if (profile.phone_number) {
      this.input.phone_number = profile.phone_number;
    }
    if (profile.dob) {
      this.input.dob = moment(profile.dob).format("YYYY-MM-DD");
    }
  },
  computed: {
    dobformat() {
      if (this.input.dob) {
        return moment(this.input.dob).format("DD/MM/YYYY");
      } else {
        return "";
      }
    },
  },
  methods: {
    submitForm() {
      return new Promise(async (resolve) => {
        if (await this.$refs.observer.validate()) {
          var data = {
            ...this.input,
            pageid: this.query.pageid,
            userid: this.userid,
            company_name: this.data.Name,
            position_name: this.data.Position,
          };
          this.saveloading = true;
          this.saveloading = false;
        }
      });
    },
    deleteWork(item, k) {
      this.input.work_experience.splice(k, 1);
    },
    deleteEdu(item, k) {
      this.input.edu_experience.splice(k, 1);
    },
    addworkexp() {
      this.input.work_experience.push({
        work_name: "",
        position: "",
        detail: "",
        years_experience: "",
      });
    },
    addeduexp() {
      this.input.edu_experience.push({
        degree: "",
        faculty: "",
        institute: "",
        grade: "",
      });
    },
    onlyNumber(event) {
      var result = event.charCode >= 48 && event.charCode <= 57;
      if (result) {
        // return result;
      } else {
        event.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>